import { useState, useEffect } from "react";
import Header from "../../header/Header";
import FadeIn from "../../../general/FadeIn";
import RoundedInput from "../../../general/RoundedInput";
import OrangeButton from "../../../general/OrangeButton";
import Api from "../../../../services/Api";

const labelStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#888",
  marginBottom: 4,
  paddingLeft: 12,
  display: "block",
};

const selectStyle = {
  width: "100%",
  padding: "16px 28px",
  borderRadius: 40,
  border: "none",
  background: "#e8e8e8",
  fontSize: 16,
  fontFamily: "'DM Sans', sans-serif",
  color: "#666",
  outline: "none",
  boxSizing: "border-box",
  cursor: "pointer",
  appearance: "none",
};

function RegisterJazigoPage({ navigate, user, onLogout, selectedFalecido }) {
  const [jazigoId, setJazigoId] = useState(null);
  const [form, setForm] = useState({
    codigo: "",
    quadra: "",
    lote: "",
    numero: "",
    tipo: "",
    status: "DISPONIVEL",
    capacidade: "",
    responsavel: "",
    telefone_responsavel: "",
    publico: true,
    observacoes: "",
  });
  const [loadingJazigo, setLoadingJazigo] = useState(true);
  const [popupError, setPopupError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedFalecido?.id) {
      setLoadingJazigo(false);
      return;
    }
    Api.getSepultamentosByFalecido(selectedFalecido.id)
      .then((sepultamentos) => {
        const sep = sepultamentos?.[0];
        if (!sep?.jazigo_id) { setLoadingJazigo(false); return; }
        setJazigoId(sep.jazigo_id);
        return Api.getJazigo(sep.jazigo_id);
      })
      .then((jaz) => {
        if (!jaz) return;
        setForm({
          codigo: jaz.codigo || "",
          quadra: jaz.quadra || "",
          lote: jaz.lote || "",
          numero: jaz.numero || "",
          tipo: jaz.tipo || "",
          status: jaz.status || "DISPONIVEL",
          capacidade: jaz.capacidade != null ? String(jaz.capacidade) : "",
          responsavel: jaz.responsavel || "",
          telefone_responsavel: jaz.telefone_responsavel || "",
          publico: jaz.publico ?? true,
          observacoes: jaz.observacoes || "",
        });
      })
      .catch(() => {})
      .finally(() => setLoadingJazigo(false));
  }, [selectedFalecido]);

  const update = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleVoltar = () => navigate("search", { selectedFalecido });

  const handleSubmit = async () => {
    if (!form.tipo || !form.status) {
      setPopupError("Tipo e status são obrigatórios.");
      return;
    }
    if (form.capacidade !== "" && Number(form.capacidade) < 0) {
      setPopupError("A capacidade não pode ser negativa.");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        codigo: form.codigo,
        quadra: form.quadra || null,
        lote: form.lote || null,
        numero: form.numero || null,
        tipo: form.tipo,
        status: form.status,
        capacidade: form.capacidade ? Number(form.capacidade) : null,
        responsavel: form.responsavel || null,
        telefone_responsavel: form.telefone_responsavel || null,
        publico: form.publico,
        observacoes: form.observacoes || null,
      };
      await Api.updateJazigo(jazigoId, payload);
      navigate("search", { selectedFalecido });
    } catch (e) {
      setPopupError(e.message || "Erro ao atualizar jazigo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#fafafa" }}>

      {popupError && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 8px 32px rgba(0,0,0,0.18)", padding: "32px 36px", maxWidth: 380, width: "90%", textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h3 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 18, fontWeight: 700, color: "#2d2d2d", marginBottom: 10 }}>
              Erro ao atualizar
            </h3>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#666", marginBottom: 24 }}>
              {popupError}
            </p>
            <button
              onClick={() => setPopupError("")}
              style={{ background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)", border: "none", color: "#fff", borderRadius: 8, padding: "10px 28px", fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600, cursor: "pointer" }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <Header
        onHome={() => navigate("search")}
        onLogin={() => navigate("login")}
        user={user}
        onLogout={onLogout}
        navigate={navigate}
      />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24 }}>
        <FadeIn delay={100}>
          <h1 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 32, fontWeight: 700, color: "#2d2d2d", textAlign: "center", marginBottom: 36 }}>
            Atualizar Jazigo
          </h1>
        </FadeIn>

        {loadingJazigo ? (
          <p style={{ fontFamily: "'DM Sans', sans-serif", color: "#aaa" }}>Carregando dados do jazigo...</p>
        ) : (
          <div style={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: 16 }}>

            <FadeIn delay={250}>
              <RoundedInput placeholder="Setor" value={form.quadra} onChange={update("quadra")} />
            </FadeIn>

            <FadeIn delay={300}>
              <RoundedInput placeholder="Lote" value={form.lote} onChange={update("lote")} />
            </FadeIn>

            <FadeIn delay={350}>
              <RoundedInput placeholder="Número" value={form.numero} onChange={update("numero")} />
            </FadeIn>

            <FadeIn delay={400}>
              <div>
                <label style={labelStyle}>Tipo *</label>
                <select value={form.tipo} onChange={update("tipo")} style={selectStyle}>
                  <option value="">Selecionar...</option>
                  {["Gaveta", "Carneiro", "Jazigo", "Ossuário", "Cripta"].map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>
            </FadeIn>

            <FadeIn delay={450}>
              <div>
                <label style={labelStyle}>Status *</label>
                <select value={form.status} onChange={update("status")} style={selectStyle}>
                  {["DISPONIVEL", "OCUPADO", "RESERVADO", "INATIVO"].map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>
            </FadeIn>

            <FadeIn delay={500}>
              <RoundedInput
                placeholder="Capacidade"
                type="number"
                value={form.capacidade}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || Number(val) >= 0)
                    setForm((prev) => ({ ...prev, capacidade: val }));
                }}
              />
            </FadeIn>

            <FadeIn delay={550}>
              <RoundedInput placeholder="Responsável" value={form.responsavel} onChange={update("responsavel")} />
            </FadeIn>

            <FadeIn delay={600}>
              <RoundedInput placeholder="Telefone do responsável" value={form.telefone_responsavel} onChange={update("telefone_responsavel")} />
            </FadeIn>

            <FadeIn delay={650}>
              <RoundedInput placeholder="Observações" value={form.observacoes} onChange={update("observacoes")} />
            </FadeIn>

            <FadeIn delay={700}>
              <label style={{ display: "flex", alignItems: "center", gap: 10, paddingLeft: 12, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#666" }}>
                <input
                  type="checkbox"
                  checked={form.publico}
                  onChange={(e) => setForm((prev) => ({ ...prev, publico: e.target.checked }))}
                  style={{ width: 18, height: 18, accentColor: "#E8956A", cursor: "pointer" }}
                />
                Público
              </label>
            </FadeIn>

            <FadeIn delay={750}>
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <OrangeButton onClick={handleSubmit} disabled={loading}>
                  {loading ? "Atualizando..." : "Atualizar"}
                </OrangeButton>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#999", marginTop: 12 }}>
                  (* Campos obrigatórios)
                </p>
                <p
                  style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#E8956A", marginTop: 16, cursor: "pointer" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </p>
              </div>
            </FadeIn>

          </div>
        )}
      </div>
    </div>
  );
}

export default RegisterJazigoPage;
